import { Form } from 'antd'
import { useSelector } from 'react-redux'

import TenantServiceSelect from '../TenantServiceSelect'


const TenantServiceSelectField = ({ name, label, required, mode }) => {
  return (
    <Form.Item label={label} name={name} rules={[{ required: required }]}>
      <TenantServiceSelect required={required} mode={mode} />
    </Form.Item>
  );
}

TenantServiceSelectField.getValue = (values) => {
  return values.map(v => parseInt(v));
}

const DisplayValue = ({ value }) => {
  const simpleListByPk = useSelector(state => state.tenantService.simpleListByPk);
  return (
    <span>{simpleListByPk[value]?.name || value}</span>
  )
};

TenantServiceSelectField.DisplayValue = DisplayValue;


export default TenantServiceSelectField
